export default __webpack_public_path__ + "static/media/Pitiless Arm-strap.9a01e99f.jpg";